<template>
    <form name="checkout-B2C">
        <base-spinner :open="isloading"></base-spinner>
        <div class="site__body">
            <div class="block-header block-header--has-breadcrumb block-header--has-title mt-10">
                <div class="container">
                    <div class="block-header__body">
                        <div class="flexbox-page-info-container">
                            <div class="flex-item-page-info-breadcrumbs">
                                <nav class="breadcrumb block-header__breadcrumb block-header__breadcrumb--and-title-only" aria-label="breadcrumb">
                                    <ol class="breadcrumb__list">
                                        <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                        <li class="breadcrumb__item breadcrumb__item--parent">
                                            <router-link to="/cart" class="breadcrumb__item-link">
                                                View Cart
                                            </router-link>
                                        </li>
                                        <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last" aria-current="page">
                                            <span class="breadcrumb__item-link">Checkout</span>
                                        </li>
                                        <li class="breadcrumb__title-safe-area" role="presentation"></li>
                                    </ol>
                                </nav>
                            </div>
                            <div class="flex-item-page-info-title">
                                <h1 class="block-header__breadcrumb-slim">Checkout</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="checkout block">
                <div class="container container--max--xl">
                    <div class="row">
                        <div class="col-12 mb-3" v-if="!userIsAuthenticated">
                            <div class="alert alert-lg alert-primary">
                                Returning customer? 
                                <router-link to="/login">Click here to login</router-link>
                            </div>
                        </div>
                        
                        <div class="col-12">
                            <base-message
                            v-if="!isloading"
                            :servermessages="servermessages"></base-message>
                        </div>

                        <div class="col-12 col-md-12" v-if="toperrormsgs.length > 0 || servermessages.length > 0">
                            <div class="alert alert-danger mb-3">
                                <!-- <strong>Please correct all of the errors listed below before proceding. <br/></strong> -->
                                <strong v-for="message in toperrormsgs" :key="message">
                                    {{ message }} <br/>
                                </strong> 
                            </div>
                        </div>

                        <div class="col-12 col-lg-6 col-xl-7">
                            <div class="card mb-lg-0">
                                <billing-details-new ></billing-details-new>
                                <div class="card-divider"></div>
                                <shipping-details-new>
                                    </shipping-details-new>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-5 mt-4 mt-lg-0">
                            <div class="card mb-0">
                                <div class="card-body card-body--padding--1">
                                    <h3 class="card-title">Your Order</h3>	
                                    <products-ordered :isCartItems="true"></products-ordered>
                                    
                                    <div class="block-space block-space--layout--divider-thin"></div>
									<div class="block-space block-space--layout--divider-thin"></div>

                                    <promotional-code></promotional-code>
                                    <div class="block-space block-space--layout--divider-thin"></div>
									<div class="block-space block-space--layout--divider-thin"></div>
									<div class="block-space block-space--layout--divider-thin"></div>                   
                                    <checkout-totals-c></checkout-totals-c>

									<div class="card-divider"></div>
									<div class="block-space block-space--layout--divider-thin"></div>
									<div class="block-space block-space--layout--divider-thin"></div>
									<div class="block-space block-space--layout--divider-thin"></div>
									<div class="block-space block-space--layout--divider-thin"></div>

                                    <payment-methods-c></payment-methods-c>
                                    <div class="checkout__agree form-group" v-if="cc_details.cc_saved_id == ''">
                                        <div class="form-check">
                                            <span class="input-check form-check-input">
                                                <span class="input-check__body">
                                                    <input class="input-check__input" type="checkbox" id="save-cc-info" @change="cc_save" v-model="checkCCSave" value='Y'>
                                                    <span class="input-check__box"></span>
                                                    <span class="input-check__icon"><svg width="9px" height="7px">
                                                            <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                        </svg>
                                                    </span>
                                                </span>
                                            </span>
											<label class="form-check-label" for="save-cc-info">
                                                Save credit card details to my account
                                            </label>
                                        </div>
                                    </div>
									<div class="checkout__agree form-group">
                                        <div class="form-check">
                                            <span class="input-check form-check-input">
                                                <span class="input-check__body">
                                                    <input class="input-check__input" type="checkbox" id="checkout-terms" v-model="isTermChecked">
                                                    <span class="input-check__box"></span>
                                                    <span class="input-check__icon"><svg width="9px" height="7px">
                                                            <path d="M9,1.395L3.46,7L0,3.5L1.383,2.095L3.46,4.2L7.617,0L9,1.395Z" />
                                                        </svg>
                                                    </span>
                                                </span>
                                            </span>
                                            <label class="form-check-label" for="checkout-terms">
                                                I have read and agree to the website <a target="_blank" href="">terms and conditions</a>.
                                            </label>
                                        </div>
                                    </div>
                                    <!-- <router-link to="/order-success" class="btn btn-checkout btn-xl btn-block">Place Order</router-link> -->
                                    <button class='btn btn-checkout btn-xl btn-block' @click="form_validation" type="button">Place Order</button>
                                    <div class="block-space--layout--divider-nl"></div><br>
									<div v-if="showShipCutOffTime">
                                        <strong>Next Shipping Cutoff Time is {{cutOffTime}} in <span class='notranslate'>{{ cntdown }}</span>.</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-space block-space--layout--before-footer"></div>
        </div>
    </form>

    <base-dialog title="User already Exists" @close="existUser = false" :open="existUser">
        <template #default>
            <p>We found your Phone number already exists in our record. You can login or proceed to checkout and create new user.</p>
        </template>
        <template #actions>
        <button type="button" class="btn btn-sm btn-secondary" @click="confirm_proceed">
            Proceed To CHECKOUT
        </button>
        <router-link to="/login"  class="btn btn-sm btn-primary" @click="existUser = false">
            Proceed To LOGIN
        </router-link>

        </template>
    </base-dialog>
</template>

<script>
import BillingDetailsNew from './BillingDetailsNew';
import ShippingDetailsNew from './ShippingDetailsNew';
import ProductsOrdered from '../checkoutb2b/ProductsOrdered';
import CheckoutTotalsC from './CheckoutTotalsC'; 
import PaymentMethodsC from './PaymentMethodsC'; 
import PromotionalCode from './PromotionalCode'; 
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';
import Formatter from '../../../mixins/formatter.js';

export default {
    name: 'CheckoutB2C',
    components: {
        BillingDetailsNew, 
        ShippingDetailsNew,
        ProductsOrdered,
        CheckoutTotalsC,
        PaymentMethodsC ,
        PromotionalCode   
    },
    data() {
        return {
            isLoggedIn : false,
            billingname: '',
            billingaddress1: '',
            billingaddress2: '',
            billingcity: '',
            billingstate: '',
            billingzip: '',
            billingcountry: '',
            billingphone: 0,
            shippingname: '',
            shippingaddress1: '',
            shippingaddress2: '',
            shippingcity: '',
            shippingstate: '',
            shippingzip: '',
            shippingcountry: '',
            shippingphone: 0,
            customeremail: '',

            checkCCSave: false,
            isTermChecked: false,
            CCSAVE: 'N',
            ADCNNM: null,
            S2CNNM: null,
            newpassword: null,
            orderTotal: 0,
            isFormValid: true,

            // created order data
            EHCUST: '',
            EOORD: null,
            phone: null,
            FORCENEWCUST: 'N',

            termsacceptance: [],
            isloading: false,
            errormessages: [],
            toperrormsgs: [],
            servermessages: [],
            cntdown: '',

            existUser: false,
        }
    },
    mixins: [Formatter],
    methods: {
        /**
         * force to create new user
         */
        confirm_proceed() { 
            this.FORCENEWCUST = 'Y';
            this.existUser = false;
            this.EHCUST = '';
            // submit order
            this.cc_placeOrder();
        },
        form_validation () {
            this.isloading = true;
            this.isFormValid = true;

            this.errormessages = [];
            this.toperrormsgs = [];

            const passwords = this.$store.getters.passwords;
            // const carrier = this.$store.getters['cart/carrier'];
            const totals = this.$store.getters['cart/totals'];
            this.servermessages = [];
            this.errormessages = [];
            let billingdetails = this.$store.getters['cart/billingdetails'];
            let cc_details = this.$store.getters['cart/cc_details'];
            let shippingdetails = this.$store.getters['cart/shippingdetails'];
            this.customeremail = this.$store.getters['cart/email'];

            // console.log(this.$store.getters['api/ce_check_user']);
            
            /** Validate billing details */
            if(billingdetails.billingname.trim() == ''){
                // this.servermessages.push('First name and Last name is required.')
                this.errormessages.push({'input' : 'BName', 'message': 'First name and Last name is required.'});
                this.isFormValid = false;
            }

            if(this.customeremail == ''){
                // this.servermessages.push('Email is required.')
                this.errormessages.push({'input' : 'BEmail', 'message': 'Email is required.'});
                this.isFormValid = false;
            }

            if(billingdetails.billingaddress1.trim() == ''){
                // this.servermessages.push('Address is required.')
                this.errormessages.push({'input' : 'BAddress', 'message': 'Address is required.'});
                this.isFormValid = false;
            }

            if(billingdetails.billingphone == ''){
                // this.servermessages.push('Phone number is required.')
                this.errormessages.push({'input' : 'BPhone', 'message': 'Phone number is required.'});
                this.isFormValid = false;
            }

            if(billingdetails.billingcity.trim() == ''){
                // this.servermessages.push('City is required.');
                this.errormessages.push({'input' : 'BCity', 'message': 'City is required.'});
                this.isFormValid = false;
            }

            if(billingdetails.billingstate.trim() == ''){
                // this.servermessages.push('State is required.')
                this.errormessages.push({'input' : 'BState', 'message': 'State is required.'});
                this.isFormValid = false;
            }

            if(billingdetails.billingzip.trim() == ''){
                // this.servermessages.push('Zip is required.')
                this.errormessages.push({'input' : 'BZip', 'message': 'Zip is required.'});
                this.isFormValid = false;
            }
            
            // console.log(shippingdetails);
            // console.log(this.shippingDifferent);

            /** Validate Shipping */
            if(this.shippingDifferent == true){
                if(shippingdetails.shippingname.trim() == ''){
                    // this.servermessages.push('Shipping Name is required.')
                    this.errormessages.push({'input' : 'SName', 'message': 'Shipping Name is required.'});
                    this.isFormValid = false;
                }

                if(shippingdetails.shippingcity.trim() == ''){
                    // this.servermessages.push('Shipping Name is required.')
                    this.errormessages.push({'input' : 'SCity', 'message': 'Shipping City is required.'});
                    this.isFormValid = false;
                }

                if(shippingdetails.shippingaddress1.trim() == ''){
                    // this.servermessages.push('Shipping Address is required.')
                    this.errormessages.push({'input' : 'SAddress', 'message': 'Shipping Address is required.'});
                    this.isFormValid = false;
                }

                if(shippingdetails.shippingphone == ''){
                    // this.servermessages.push('Shipping Phone is required.')
                    this.errormessages.push({'input' : 'SPhone', 'message': 'Shipping Phone is required.'});
                    this.isFormValid = false;
                }

                if(shippingdetails.shippingzip.trim() == ''){
                    // this.servermessages.push('Shipping State is required.')
                    this.errormessages.push({'input' : 'SZip', 'message': 'Zip is required.'});
                    this.isFormValid = false;
                }

                if(shippingdetails.shippingstate.trim() == ''){
                    // this.servermessages.push('Shipping State is required.')
                    this.errormessages.push({'input' : 'SState', 'message': 'Shipping State is required.'});
                    this.isFormValid = false;
                }
            }

            // if selected saved cc
            // console.log(cc_details);
            if (cc_details.cc_saved_id == ''){
                console.log(cc_details);
                /** Validate Credit Card details */
                if(cc_details.cc_fname == null || cc_details.cc_lname == null){
                    // this.servermessages.push('Credit Card Name is required.');
                    this.errormessages.push({'input' : 'CC_Name', 'message': 'Credit Card Name is required.'});
                    this.isFormValid = false;
                }

                if(cc_details.cc_exp_mo == null ){
                    // this.servermessages.push('Credit Card Expiration month is required.')
                    this.errormessages.push({'input' : 'CC_Mo', 'message': 'Expiration month is required.'});
                    this.isFormValid = false;
                }

                if(cc_details.cc_exp_yr == null){
                    // this.servermessages.push('Credit Card Expiration year is required.');
                    this.errormessages.push({'input' : 'CC_Year', 'message': 'Expiration Year is required.'});
                    this.isFormValid = false;
                }

                if(cc_details.cc_cvv == null){
                    this.errormessages.push({'input' : 'CC_CVV', 'message': 'CVV is required.'});
                    this.isFormValid = false;
                }
                
                if(cc_details.cc_zip == null){
                    // this.servermessages.push('Credit Card Zipcode is required.');
                    this.errormessages.push({'input' : 'CC_Zip', 'message': 'Zipcode is required.'});
                    this.isFormValid = false;
                }
            }
            
            if(!this.isLoggedIn){
                if(passwords.newpassword != passwords.repassword){
                    // this.servermessages.push('Password is not matched.');
                    this.errormessages.push({'input' : 'RePWord', 'message': 'Password is not matched.'});
                    this.isFormValid = false;
                }

                if(passwords.newpassword === null){
                    // this.servermessages.push('Password is required.')
                    this.errormessages.push({'input' : 'PWord', 'message': 'Password is required.'});
                    this.isFormValid = false;
                }else{
                    this.newpassword = passwords.newpassword;
                }
            }


            if(!this.isTermChecked) {
                this.toperrormsgs.push('Please accept the website terms and conditions to place your order.');
                this.isFormValid = false;
            }

            // issue #134
            // https://gitlab.com/lansa/dms_ecommerce/-/issues/134#note_630241271
            // remove validation of carrier
            // if(carrier == null || carrier == '') {
            //     this.servermessages.push('Carrier is required.')
            //     this.isFormValid = false;
            // }
            // end issue #134
            
            if (totals[0].ordertotal <= 0) {
                this.toperrormsgs.push('Total is 0. Nothing to checkout.');
                this.isFormValid = false;
            }else{
                this.orderTotal = parseFloat(totals[0].ordertotal);
                // additional 10% as request of Grady for CC checkout
                // this.orderTotal = this.orderTotal + (parseFloat(this.ordertotal) * 0.1);
                // console.log(totals[0].ordertotal);
                // console.log(this.ordertotal * 1.1);
            }

            console.log(this.isFormValid);
            console.log(this.errormessages);

            if (this.isFormValid){
                this.cc_placeOrder();
            }else{
                this.isloading = false;
            }

            
            // console.log(this.errormessages);
            this.$store.dispatch('setErrorFields', this.errormessages);

            return this.isFormValid;
        },

        cc_placeOrder() {
            let parts = [];
            this.isloading = true;

            parts = this.buildPartsToOrder();
            let billingdetails = this.$store.getters['cart/billingdetails'];
            let shippingdetails = this.$store.getters['cart/shippingdetails'];
            let cc_details = this.$store.getters['cart/cc_details'];
            const cc_new_order_uri = this.$store.getters['api/cc_new_order'];
            this.customeremail = this.$store.getters['cart/email'];
            this.phone = billingdetails.billingphone;
            const totals = this.$store.getters['cart/totals'];
            this.orderTotal = parseFloat(totals[0].ordertotal);
            
            const params = {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "B2CTEMPLATE": {"value": this.$store.getters.customer},
                        "PPICC": {"value": cc_details.cc_token},
                        "MNTH": {"value": cc_details.cc_exp_mo},
                        "YR": {"value": cc_details.cc_exp_yr},
                        "CCCVV": {"value": cc_details.cc_cvv},
                        "CCFIRST": {"value": cc_details.cc_fname},
                        "CCLAST": {"value": cc_details.cc_lname},
                        "CCADDR": {"value": cc_details.cc_address},
                        "CCZIP": {"value": cc_details.cc_zip},
                        "CCSAVE": {"value": this.CCSAVE},
                        "CCSAVED": {"value": cc_details.cc_saved_id},
                        "CCTOT": {"value": this.orderTotal},
                        // TETYPE is blank because of new customer
                        "TETYPE": {"value": 'MC'},

                        "EHCUST": {"value": this.EHCUST},
                        // "EHCUST": {"value": this.$store.getters.customer},
                        "EHPONO": {"value": this.$store.getters['cart/purchaseorder']},
                        "EHCARR": {"value": this.$store.getters['cart/carrier']},
                        "EHORD#": {"value": ""},

                        "CMNAME": {"value": billingdetails.billingname},
                        "ECEMAL": {"value": this.customeremail},
                        "UPPASS": {"value": this.newpassword},
                        "ADNAME": {"value": billingdetails.billingname},
                        "ADADD1": {"value": billingdetails.billingaddress1},
                        "ADADD2": {"value": billingdetails.billingaddress2},
                        "ADCITY": {"value": billingdetails.billingcity},
                        "ADSTTC": {"value": billingdetails.billingstate},
                        "ADCTRC": {"value": billingdetails.billingcountry},
                        "ADZIPC": {"value": billingdetails.billingzip},
                        "ADPHON": {"value": billingdetails.billingphone.replace('-', '')},
                        "ADCNNM": {"value": this.ADCNNM},
                        
                        "S2NAME": {"value": shippingdetails.shippingname},
                        "S2ADD1": {"value": shippingdetails.shippingaddress1},
                        "S2ADD2": {"value": shippingdetails.shippingaddress2},
                        "S2CITY": {"value": shippingdetails.shippingcity},
                        "S2STTC": {"value": shippingdetails.shippingstate},
                        "S2CTRC": {"value": shippingdetails.shippingcountry},
                        "S2ZIPC": {"value": shippingdetails.shippingzip},
                        "S2PHON": {"value": shippingdetails.shippingphone},
                        "S2CNNM": {"value": this.S2CNNM},

                        "FREIGHT": {"value": totals[0].shippingtotal},
                        "TAXES": {"value": totals[0].taxtotal},
                        "CEDKOE": {"value": this.cedkoe},

                        "FORCENEWCUST": {"value": this.FORCENEWCUST},
                        "ORDMSG": {"value": this.$store.getters['cart/ordernotes']}
                    },
                    "lists": {
                        "PARTSO": {
                            "header": [
                                {"name": "EKMFGC"},
                                {"name": "EKITMC"},
                                {"name": "EKOQTY"},
                                {"name": "EKBOCD"},
                                {"name": "EKCPO#"},
                                {"name": "EKLOCN"},
                                {"name": "EKCARR"},
                                {"name": "EKEXCP"},
                                {"name": "EKCORP"},
                                {"name": "EKKITF"},
                            ],
                            "entries": parts
                        }
                    }
                }
            };

            // for testing 
            // console.log(params);
            // const test = true;
            // if(test){
            //     return false;
            // }
            // if (!this.form_validation()) {
            //     this.servermessages = ['Please see error below'];
            //     return false;
            // }

            axiosvl.post(cc_new_order_uri, params)
            .then((response) => {
                const fields = response.data.webroutine.fields
                let messages = [];
                this.isloading = false;
                // Return code is not "OK" but no messages appear, add a custom error message
                // if (messages.length === 0) {
                //     messages.push("Something went wrong. Please try again later.");
                // }

                if (fields.RESULTCOD.value === 'CUSTEXIST') {
                    this.existUser = true;
                    return;
                }

                if (fields.RESULTCOD.value === 'OK') {
                    // clear the cart
                    // this.$store.dispatch('cart/emptyCart');
                    
                    this.EOORD = fields['EOORD#'].value;

                    // check if B2C customer is already registered
                    if(this.EHCUST == ''){
                        this.EHCUST = fields.CMCUST.value;
                        this.createCEUser().then(res => {
                            this.afterPlaceOrder(res, response);
                            // if(res){
                            //     this.$router.push("/order-success");
                            // }
                        });
                    }else{
                        this.EHCUST = fields.CMCUST.value;
                        this.afterPlaceOrder(true, response);
                    }
                    
                }else{
                    let HDM = this.storefrontAttributes.find(attribute => attribute.type === 'HDM').value;

                    if(fields.RESULTCOD.value === 'PAYFAIL'){
                        this.toperrormsgs.push("Credit card payment unsuccessful. Please contact Customer Service.");
                    }else{
                        this.toperrormsgs.push("Your order could not be placed. Please contact Customer Service.");
                    }

                    if(HDM != 'Y'){
                        const wrmessages = response.data.webroutine.messages;
                        for (var i = 0; i < wrmessages.length; i++) {
                            // console.log(wrmessages[i]);
                            this.toperrormsgs.push(wrmessages[i]);
                        }
                    }

                }

                
                this.servermessages = messages;
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
                this.toperrormsgs.push("Credit card payment unsuccessful. Please contact Customer Service.");
                this.toperrormsgs.push(error.message); 
                let HDM = this.storefrontAttributes.find(attribute => attribute.type === 'HDM').value;
                if(HDM != 'Y'){
                    this.toperrormsgs.push(error);  
                }
            });
        },

        buildPartsToOrder() {
            let parts = [];
            console.log(this.getDefaultLocationDetails);
            this.$store.getters['cart/cart'].forEach(cartitem => {
                let itemlocation = cartitem.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : cartitem.locationid;
                // let isBackOrder = (cartitem.backorder == true) ? "Y" : "";
                parts.push([
                    cartitem.manufacturer, // EKMFGC
                    cartitem.item,      // EKITMC
                    cartitem.quantity, // EKOQTY
                    '',        // EKBOCD
                    "",                 // EKCPO#
                    itemlocation, // EKLOCN
                    cartitem.carrier, // EKCARR
                    cartitem.yourprice,  // EKEXCP
                    cartitem.corecharge, // EKCORP
                    '',                  // EKKITF
                ]);
            });

            this.$store.getters['cart/kits'].forEach(kitem => {
                let itemlocation = kitem.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : kitem.locationid;
                // let isBackOrder = (kitem.backorder == true) ? "Y" : "";
                parts.push([
                    kitem.mfgcode, // EKMFGC
                    kitem.kitnumber,      // EKITMC
                    kitem.quantity, // EKOQTY
                    '', // EKBOCD
                    "", // EKCPO#
                    itemlocation, // EKLOCN
                    kitem.carrier, // EKCARR
                    kitem.yourprice,  // EKEXCP
                    kitem.corecharge, // EKCORP
                    kitem.EKKITF, // EKKITF
                ]);

                kitem.kit_items.forEach(kcomp => {
                    let itemlocation = kcomp.locationid === undefined ? this.getDefaultLocationDetails.defaultlocationid : kcomp.locationid;
                    // let isBackOrder = (kcomp.backorder == true) ? "Y" : "";
                    parts.push([
                        kcomp.manufacturer, // EKMFGC
                        kcomp.item,      // EKITMC
                        kcomp.quantity, // EKOQTY
                        '', // EKBOCD
                        "", // EKCPO#
                        itemlocation, // EKLOCN
                        kcomp.carrier, // EKCARR
                        kcomp.yourprice,  // EKEXCP
                        kcomp.corecharge, // EKCORP
                        'C'                  // EKKITF
                    ]);
                });
            });

            return parts;
        },

        /**
         * create customer record
         * at CE ADMIN
         */
        createCEUser() {
            const create_user_uri = this.$store.getters['api/ce_create_user'];
            const passwords = this.$store.getters.passwords;
            const params = {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        // "HOSTURL": {"value": this.$store.getters.hosturl},
                        "LW3SFID": { "value": this.$store.getters.storefront },
                        "LW3CWPHNE": {
                            "value": this.EHCUST
                        },
                        "LW3CEMAIL": {
                            "value": this.customeremail
                        },
                        "LW3USRNPW": {
                            "value": passwords.newpassword
                        },
                        "LW3USRPS2": {
                            "value": passwords.repassword
                        },
                        "LW3WEBC01": {
                            "value": this.EHCUST
                        }
                    }
                }
            };

            return axiosvl.post(create_user_uri, params)
            .then((response) => {
                // console.log(response);
                this.isloading = false;
                const fields = response.data.webroutine.fields
                if(fields.LW3RETCOD.value == 'OK') {
                    // redirect to order success
                    // this.$router.push("/order-success");
                    return true;
                }else{
                    return false;
                    // void the payment
                }
            })
            .catch((error) => {
                
                console.log("error - " + error);
            });
        },

        /**
         * check the customer if registered at CE ADMIN
         * 
         */
        checkCEUser(){
            // if the user is already logged in.
            // move to place order directly
            if(this.isLoggedIn){
                this.cc_placeOrder();
                return;
            }

            const check_user_uri = this.$store.getters['api/ce_check_user'];
            let billingdetails = this.$store.getters['cart/billingdetails'];
            const params = {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        // "HOSTURL": {"value": this.$store.getters.hosturl},
                        "LW3SFID": { "value": this.$store.getters.storefront },
                        "LW3CWPHNE": {
                            "value": billingdetails.billingphone.replace('-', '')
                        }
                    }
                }
            };

            axiosvl.post(check_user_uri, params)
            .then(() => {
                // const fields = response.data.webroutine.fields
                // // NR means no RECORD
                // if(fields.LW3RETCOD.value == 'NR'){
                //     this.EHCUST = '';
                //     this.FORCENEWCUST = 'Y';
                //     // submit order
                //     this.cc_placeOrder();
                // }else{
                //     // this.isFormValid = false;
                //     // this.servermessages.push('Your phone number is already registered as a user. Would you like to login your account?');
                //     this.EHCUST = fields.LW3WEBC01.value;
                //     this.FORCENEWCUST = 'N';
                //     this.existUser = true;
                // }
                // this.isloading = false;
            })
            .catch((error) => {
                // this.isloading = false;
                console.log("error - " + error);
            });
        },

        cc_save() {
            if (this.checkCCSave){
                this.CCSAVE = 'Y';
            }else{
                this.CCSAVE = 'N';
            }
        },

        getCustomerInfo() {
            this.isloading = true;
            this.servermessages = [];

            this.billingname = '', this.billingaddress1 = '', this.billingaddress2 = '', this.billingcity = '', this.billingstate = '', this.billingzip = '', this.billingphone = '', this.shippingname = '', this.shippingaddress1 = '', this.shippingaddress2 = '', this.shippingcity = '', this.shippingstate = '', this.shippingzip = '', this.shippingphone = '', this.customeremail = '';

            axiosvl.post(this.$store.getters['api/get_customer_info_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields
                let messages = [];

                if (fields.RESULTCOD.value === 'OK') {
                    this.billingname = fields.ADNAME.value;
                    this.billingaddress1 = fields.ADADD1.value;
                    this.billingaddress2 = fields.ADADD2.value;
                    this.billingcity = fields.ADCITY.value;
                    this.billingstate = fields.ADSTTC.value;
                    this.billingzip = fields.ADZIPC.value;
                    this.billingcountry = fields.ADCTRC.value;
                    this.billingphone = fields.ADPHON.value;
                    this.CMNAME = fields.CMNAME.value;
                    this.ADCNNM = fields.ADCNNM.value;
                    this.S2CNNM = fields.S2CNNM.value;
                    if (fields.S2NAME.value === '' && fields.S2ADD1.value === '') {
                        this.shippingname = fields.ADNAME.value;
                        this.shippingaddress1 = fields.ADADD1.value;
                        this.shippingaddress2 = fields.ADADD2.value;
                        this.shippingcity = fields.ADCITY.value;
                        this.shippingstate = fields.ADSTTC.value;
                        this.shippingzip = fields.ADZIPC.value;
                        this.shippingphone = fields.ADPHON.value;
                    } else {
                        this.shippingname = fields.S2NAME.value;
                        this.shippingaddress1 = fields.S2ADD1.value;
                        this.shippingaddress2 = fields.S2ADD2.value;
                        this.shippingcity = fields.S2CITY.value;
                        this.shippingstate = fields.S2STTC.value;
                        this.shippingzip = fields.S2ZIPC.value;
                        this.shippingcountry = fields.S2CTRC.value;
                        this.shippingphone = fields.S2PHON.value;
                    }
                    this.customeremail = fields.ECEMAL.value;

                } else {
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    // Return code is not "OK" but no messages appear, add a custom error message
                    if (messages.length === 0) {
                        messages.push("Something went wrong. Please try again later.");
                    }
                }

                this.isloading = false;
                this.servermessages = messages;
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        },

        shipCutOffTimer(){
            let time = parseInt(this.storefrontAttributes.find(attribute => attribute.type === 'SCT').value);
            time = time.toString().substring(0, 2) + ':' + time.toString().substring(2, 4);
            const STZ_val = this.storefrontAttributes.find(attribute => attribute.type === 'STZ').value;
           
            var currYear = new Date().getFullYear();
            var currDay = new Date().getUTCDate();
            var currMo = new Date().getUTCMonth() + 1;
            var setDate = currMo + '/'+ currDay + '/'+ currYear + " " + time + " " + STZ_val;

            const cutoff = new Date(setDate);
            const today = new Date();
            
            var diff = cutoff - today;  

            var msec = diff;
            var hh = Math.floor(msec / 1000 / 60 / 60);
            msec -= hh * 1000 * 60 * 60;
            var mm = Math.floor(msec / 1000 / 60);
            msec -= mm * 1000 * 60;
            var ss = Math.floor(msec / 1000);
            
            if(hh.toString().length == 1){
                hh = '0' + hh;
            }

            if(mm.toString().length == 1){
                mm = '0' + mm;
            }
            
            if(ss.toString().length == 1){
                ss = '0' + ss;
            }
            
            this.cntdown = hh + ':' + mm + ':' + ss;
        },

        afterPlaceOrder(res, res_api){
            const fields = res_api.data.webroutine.fields
            const lists = res_api.data.webroutine.lists;
            const OSDETS_list = lists.OSDETS.entries;
            // console.log('res = ' + res);
            if(res == true){

                this.$store.dispatch('cart/ordersuccess', {
                    ordernumber: fields['HAORD#'].value,
                    orderdate: fields.XROESM.value + '/' + fields.XROESD.value + '/' + fields.XROESY.value,
                    paymentmethod: 'Credit Card',
                });
                
                // build ordered items fromo the response
                this.ordered_items = [];

                OSDETS_list.forEach(item => {

                    if(item.DIDESC.indexOf("KIT END") >= 0){
                        this.kit_po =  item.DICPONUM;
                        this.kit_ord_num =  item.DIORDNUM;
                        // console.log('KIT END SKIP');
                        return;
                    }

                    const isProd = this.cart.find(c => (c.item == item.DIITMC) && (c.manufacturer == item.DIMFGC));

                    if(!isProd){
                        return;
                    }

                    // console.log(item);
                    this.ordered_items.push({
                        "po_number"     : item.DICPONUM,
                        "ord_number"    : item.DIORDNUM,
                        "product_id"    : item.DIITMC,
                        "product_name"  : item.DIITMC,
                        "product_dessc" : item.DIDESC,
                        "image"         : this.getProductImage(item.DIITMC),
                        "XRITMC"        : '',
                        // "product_desc": item.desc,
                        "price"         : item.DIEPRX,
                        "quantity"      : item.DIORQT,
                        "bo_quantity"   : item.DIBOQX,
                        "total_item"    : item.TOLITM,

                        "customer"      : item.DICUST,
                        "customer_desc" : item.DIDESC,

                        "locationid"    : item.DILOC,
                        "locationcity"  : item.ADCITY,
                        "locationname"  : item.LCNAME,
                        "locationnamel" : item.LCNAMEL,
                        "locationstate" : item.ADSTTC,
                        "manufacturer"  : item.DIMFGC,

                        "kit_components": []
                    });
                });

                this.kits.forEach(km => {
                    // console.log(item);
                    this.ordered_items.push({
                        "po_number"     : this.kit_po,
                        "ord_number"    : this.kit_ord_num,
                        "product_id"    : km.kitnumber,
                        "product_name"  : km.desc,
                        "product_desc"  : km.desc,
                        "image"         : this.getProductImage(km.kitnumber),
                        "XRITMC"        : '',
                        // "product_desc": item.desc,
                        "price"         : km.kit_gtotal,
                        "quantity"      : km.kitqy,
                        "bo_quantity"   : '',
                        "total_item"    : '',
                        "customer"      : this.$store.getters.customer,
                        // "customer_desc": item.DIDESC,
                        "locationid"    : km.locationid,
                        "locationcity"  : km.locationcity,
                        "locationname"  : km.locationid,
                        "locationnamel" : '',
                        "locationstate" : km.locationstate,
                        "manufacturer"  : km.mfgcode,
                        
                        "order_number"  : this.kit_ord_num,
                        "kit_components": km.kit_items
                    });
                });

                console.log(this.ordered_items);
                this.$store.dispatch('cart/ordered_items', this.ordered_items);
                this.$router.push("/order-success");
            }else{
                this.toperrormsgs.push("Your order could not be placed. Please contact Customer Service.");
                return false;
            }
        },

        // get product image
        getProductImage(product_id) {
            let kitc;
            // product / items
            const prod = this.$store.getters['cart/cart'].find(item => {
                return (item.ID == product_id)
            });
            
            if(prod){
                return prod.image;
            }

            // kit master
            const kitm = this.$store.getters['cart/kits'].find(kit => {
                return (kit.kitnumber == product_id)
            });

            if(kitm){

                return kitm.image;
            }

            // kit components
            this.$store.getters['cart/kits'].forEach(kit => {
                kitc = kit.kit_items.find(i => (i.item == product_id));
            });

            if(kitc){
                return kitc.image;
            }

            return '';
        },
    },

    updated() {
    //   console.log(this.cc_details.cc_saved_id);
        // console.log('updated');
    },

    mounted() {
        this.shipCutOffTimer();
        setInterval(this.shipCutOffTimer, 1000);

        this.isLoggedIn = this.$store.getters.userIsAuthenticated;
        
        if (this.isLoggedIn) {
            if (this.customerIndicator === 'B') {
                this.$router.push("/checkout-business");
            } else {
                this.FORCENEWCUST = "N";
                this.EHCUST = this.$store.getters.customer;
                this.getCustomerInfo();
            }
        } else{
            this.FORCENEWCUST = "N";
        }
    },
    computed: {
        ...mapGetters([
            'userIsAuthenticated',
            'customerIndicator',
            'storefrontAttributes',
        ]),
        ...mapGetters("cart", [
            "cc_details",
            "shippingDifferent",
            "kits",
            'cart',
            "totals",
            "cedkoe"
        ]),

        showShipCutOffTime() {
            if (this.storefrontAttributes.length > 0) {
                return this.storefrontAttributes.find(attribute => attribute.type === 'SST').value === 'Y';
            } else {
                return false;
            }
        },

        cutOffTime(){
            let time = parseInt(this.storefrontAttributes.find(attribute => attribute.type === 'SCT').value);
            time = time.toString().substring(0, 2) + ':' + time.toString().substring(2, 4);
            const STZ_val = this.storefrontAttributes.find(attribute => attribute.type === 'STZ').value;
            console.log(STZ_val);

            var currYear = new Date().getFullYear();
            var currDay = new Date().getUTCDate();
            var currMo = new Date().getUTCMonth() + 1;
            var setDate = currMo + '/'+ currDay + '/'+ currYear + " " + time + " " + STZ_val;
            // var setDate = "7/22/2021 16:15 GMT-05:00";
            
            const d = new Date(setDate);
            // console.log(d);
            const localTime = d.toLocaleTimeString();
            // console.log(localTime);
            const localArr = localTime.split(" ");
            // console.log(localArr);
            const timeArr = localArr[0].split(':');
            const hhmm = timeArr.slice(0, 2).join(':');
            const ampm = (localArr[1] != undefined) ? localArr[1] : 'AM'; 

            return hhmm + ampm;
        },

        cutOffM() {
            let time = parseInt(this.storefrontAttributes.find(attribute => attribute.type === 'SCT').value);

            if (time > 1200){
                return 'pm';
            }else{
                return 'am';
            }

        },

        cutOffTimeZone() {
            return this.storefrontAttributes.find(attribute => attribute.type === 'STZ').value;
        },
    },

    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
    }
}
</script>

